import { WebSocketsProvider } from '@motorway/motorway-handshake-components';

import { useDriver } from '../../contexts/Driver';

export const WebSocketsWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { driver } = useDriver();

  return (
    <WebSocketsProvider token={driver?.token ?? null} enquiryId={driver?.enquiryId ?? null}>
      {children}
    </WebSocketsProvider>
  );
};
